module.exports = __webpack_public_path__ + "static/media/carousel-4.6f8d909a.jpg";